import { useNavigate } from "react-router-dom"
import { useSnackbar } from "../../../context/snackbar"

function ListCard({ list }) {
  const navigate = useNavigate()
  const { showSnackbar } = useSnackbar()

  const API = `${process.env.REACT_APP_API_URL}/api/lists`

  /* =========================
     DELETE LIST
  ========================= */
  const deleteList = async () => {
    try {
      const res = await fetch(`${API}/${list._id}`, {
        method: "DELETE",
        credentials: "include",
      })

      const data = await res.json()

      if (!res.ok) {
        showSnackbar(data.message || "Failed to delete list", "error")
        return
      }

      showSnackbar("List deleted successfully", "success")

      // optional: soft refresh instead of reload
      window.location.reload()
    } catch (err) {
      console.error(err)
      showSnackbar("Something went wrong", "error")
    }
  }

  return (
    <>
      {/* =========================
          LIST CARD
      ========================= */}
      <div className="ap-cat-card col-lg-6 col-md-8 col-sm-10 d-flex mx-auto my-3">
        <div className="ap-cat-card-inner col-12 d-flex border ps-3 pe-4 align-items-center">
          {/* INFO */}
          <div className="col-6 fs-4">
            {list.name}
            <div className="small text-muted">
              {list.items?.length || 0} items
            </div>
          </div>

          {/* VIEW */}
          <button
            className="col-3 btn btn-primary me-2"
            onClick={() => navigate(`/lists/${list._id}`)}
          >
            View
          </button>

          {/* DELETE TRIGGER */}
          <button
            className="col-3 btn btn-danger"
            data-bs-toggle="modal"
            data-bs-target={`#deleteListModal-${list._id}`}
          >
            Delete
          </button>
        </div>
      </div>

      {/* =========================
          DELETE MODAL (BOOTSTRAP STYLE)
      ========================= */}
      <div
        className="modal fade"
        id={`deleteListModal-${list._id}`}
        tabIndex="-1"
        aria-labelledby="deleteListLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            {/* HEADER */}
            <div className="modal-header">
              <h5 className="modal-title text-danger">Delete List</h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            {/* BODY */}
            <div className="modal-body">
              <p>Are you sure you want to delete:</p>

              <div className="fw-bold fs-5">{list.name}</div>

              <small className="text-muted">
                This action cannot be undone.
              </small>
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button className="btn btn-secondary" data-bs-dismiss="modal">
                Cancel
              </button>

              <button
                className="btn btn-danger"
                onClick={deleteList}
                data-bs-dismiss="modal"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ListCard
